import "./RatingStars.css";

const RatingStars = ({ rating, size = "md", showNumber = false, count = null }) => {
  const full = Math.floor(rating);
  const half = rating % 1 >= 0.5;

  return (
    <span className={`rs-wrap rs-${size}`} aria-label={`${rating} out of 5 stars`}>
      <span className="rs-stars" aria-hidden="true">
        {Array.from({ length: 5 }, (_, i) => (
          <span
            key={i}
            className={`rs-star ${
              i < full ? "rs-full" : i === full && half ? "rs-half" : "rs-empty"
            }`}
          >
            ★
          </span>
        ))}
      </span>
      {showNumber && <span className="rs-num">{rating.toFixed(1)}</span>}
      {count !== null && <span className="rs-count">({count})</span>}
    </span>
  );
};

export default RatingStars;
